import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_2 = { class: "flex flex-col gap-6 items-center py-2" }
const _hoisted_3 = { class: "flex flex-col border-b border-b-gray-200 pb-5 w-full px-5" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "font-semibold text-xl text-gray-900"
}
const _hoisted_6 = { class: "flex flex-row w-[100%]" }
const _hoisted_7 = { class: "font-normal text-sm text-gray-600 mt-1" }
const _hoisted_8 = { class: "flex flex-col w-full gap-3 px-4" }
const _hoisted_9 = { class: "flex items-baseline justify-between w-[100%]" }
const _hoisted_10 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_11 = { class: "form-group flex flex-col gap-3 justify-between w-[50%]" }
const _hoisted_12 = { class: "form-group flex flow-row justify-between items-center" }
const _hoisted_13 = ["for"]
const _hoisted_14 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 0,
  class: "flex items-start justify-between items-center w-[100%] mt-2"
}
const _hoisted_17 = { class: "text-sm font-medium text-gray-700 text-sm" }
const _hoisted_18 = { class: "w-[50%]" }
const _hoisted_19 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_20 = { value: "catchup" }
const _hoisted_21 = { value: "assessment" }
const _hoisted_22 = { value: "none" }
const _hoisted_23 = { class: "flex items-start justify-between items-center w-[100%] mt-2" }
const _hoisted_24 = { class: "text-sm font-medium text-gray-700 text-sm" }
const _hoisted_25 = { class: "w-[50%]" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "en-ZA" }, "English ZA", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "en-GB" }, "English GB", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "en-AU" }, "English AU", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "af-ZA" }, "Afrikaans", -1)
const _hoisted_30 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "form-group flex justify-between items-center border-b-2 border-gray-200 pb-4" }
const _hoisted_32 = {
  for: "lockedJourneys",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "active" }, "Active", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "deactivated" }, "Deactivated", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "archived" }, "Archived", -1)
const _hoisted_36 = [
  _hoisted_33,
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = { class: "w-full flex flex-col gap-3 items-center justify-center mt-2" }
const _hoisted_38 = { class: "w-full flex gap-4" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_43 = { class: "flex flex-col items-center px-12 py-8" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = {
  key: 0,
  class: "mt-5 font-medium text-xl text-gray-900"
}
const _hoisted_47 = {
  key: 1,
  class: "mt-5 font-medium text-xl text-gray-900"
}
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = {
  key: 3,
  class: "font-normal text-sm text-gray-400 mt-2 text-center"
}
const _hoisted_50 = { class: "mt-8 flex gap-4 text-base w-full" }

import { computed, onMounted, ref, watch } from "vue";
import { useLearnerStore } from "@/stores/learnerStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useFilterStore } from "@/stores/filterStore";
import { useLicenseStore } from "@/stores/licenseStore";
import { useUserStore } from "@/stores/userStore";
import SchoolLicenseComponent from "@/components/global/SchoolLicenseComponent.vue";

// Define the props that the component accepts

export default /*#__PURE__*/_defineComponent({
  __name: 'BulkEditLearnersComponent',
  props: {
  gradeLevel: {
    type: Number,
    default: 0,
    required: false,
  },
  subject: {
    type: String,
    default: "",
    required: false,
  },
  classId: {
    type: String,
    default: "",
    required: false,
  },
  preferredLanguage: {
    type: String,
    default: "en-ZA",
    required: false,
  },
  selectedStudents: {
    type: Array,
    required: false,
  },
},
  emits: ["hideModel", "resetEditModel"],
  setup(__props, { emit }) {

const props = __props;



// Initialize the stores for learners, school, and subjects
const learnerStore = useLearnerStore();
const schoolStore = useSchoolStore();
const filterStore = useFilterStore();
const licenseStore = useLicenseStore();
const subjectStore = useSubjectStore();
const userStore = useUserStore();

// Initialize reactive references
const selectedStudents = ref<string[]>([]);
const updateMultipleLearners = ref(true);
const selectedJourney = ref("");
const showEditComplete = ref(false);
const selectedLanguage = ref(props.preferredLanguage);
const selectedStatus = ref("active");
const response = ref("");
const lockedJourneys = ref({
  assessment: false,
  catchup: false,
});
const disabledBtn = ref(false);

//class update handler
const subjects = computed(() => subjectStore.getSubjects);
const selectedClasses = ref<{ [key: string]: string }>({});
const previousSelectedClasses = ref<{ [key: string]: string }>({});

// Compute classes for a given subject
const getClassesForSubject = (subjectName: string) => {
  const grade = props.gradeLevel;
  const subjectId = subjectStore.getSubjectIdByName(subjectName);

  if (!subjectId) {
    console.error(`Subject "${subjectName}" not found`);
    return ["None"];
  }

  const filteredClasses = schoolStore.getSchoolStructure?.classGroups.filter(
    (group) => group.gradeLevel === grade && group.subject === subjectId
  );

  return filteredClasses?.map((group) => ({
    name: group.name,
    id: group._id,
    preferredLanguage: group.preferredLanguage,
  }));
};

// Emit event setup


// Initialize selectedStudents with the passed prop
selectedStudents.value = props.selectedStudents as string[];

// Watch for changes in preferredLanguage prop and update selectedLanguage
watch(
  () => props.preferredLanguage,
  (newLang) => {
    selectedLanguage.value = newLang;
  }
);

// Run on component mount
onMounted(() => {
  subjects.value.forEach((subject) => {
    const learnerClass = formData.value.classes?.find((cls) => {
      return cls.subject && String(cls.subject._id) === String(subject.id);
    });
    selectedClasses.value[subject.id] = learnerClass ? learnerClass._id : "";
    previousSelectedClasses.value[subject.id] = learnerClass
      ? learnerClass._id
      : "";
  });
});
const formData = computed(() => {
  // Get the learner details from the store
  const learnerDetails = learnerStore.getSchoolLearners.filter(
    (learner) => learner._id == selectedStudents.value[0]
  );

  // Get the lockedJourneys state for the learner
  const lockedJourneys = learnerDetails[0].settings.lockedJourneys;

  const selectedLockedJourney = lockedJourneys.catchup
    ? "catchup"
    : lockedJourneys.assessment
      ? "assessment"
      : "";

  return {
    lockedJourneys: selectedLockedJourney,
    classes: learnerDetails[0].classes,
  };
});

// Function to update the lockedJourneys state based on selected journey
const updateLockedJourneys = () => {
  lockedJourneys.value.assessment = selectedJourney.value === "assessment";
  lockedJourneys.value.catchup = selectedJourney.value === "catchup";
};

// Cancel the edit process and emit hideModel event
const cancelEdit = () => {
  if (schoolStore.currentSchool?._id) {
    licenseStore.fetchLicenses(schoolStore.currentSchool?._id);
  }
  updateMultipleLearners.value = false;
  emit("hideModel");
};

// Get the subject ID by its name from the subject store
const getSubjectIdByName = (subjectName: string) => {
  const subject = filterStore.filterOptions?.subjects.find(
    (sub) => sub.name.toLowerCase() === subjectName.toLowerCase()
  );
  return subject ? subject._id : null;
};

// Mark edit process as completed and reset selected students
const editCompleted = () => {
  showEditComplete.value = false;
  selectedStudents.value = [];
  emit("hideModel");
};

// Save changes made to the selected students
const saveChanges = async () => {
  // Merge selected classes into an array
  let mergedClasses = [];
  subjects.value.forEach((subject) => {
    if (selectedClasses.value[subject.id]) {
      mergedClasses.push(selectedClasses.value[subject.id]);
    }
  });

  const learnerDetails = learnerStore.getSchoolLearners.filter(
    (learner) => learner._id == selectedStudents.value[0]
  )[0];

  const classUpdate = {
    classes: subjects.value.map((subject) => ({
      currentClass:
        learnerDetails.classes?.find((cls) => cls.subject._id === subject.id)
          ?._id || "",
      newClass: selectedClasses.value[subject.id],
    })),
  };

  // Handle multiple learners update
  if (selectedStudents.value.length > 1) {
    const newBulkClassUpdate = {
      studentIds: selectedStudents.value,
      classes: classUpdate?.classes ? classUpdate.classes : null,
      lockedJourneys: {
        assessment:
          formData.value.lockedJourneys.toLocaleLowerCase() == "assessment"
            ? true
            : false,
        catchup:
          formData.value.lockedJourneys.toLocaleLowerCase() == "catchup"
            ? true
            : false,
      },
      preferredLang: selectedLanguage.value,
      status: selectedStatus.value,
    };

    //Perform bulk update through the store
    const request = await learnerStore.bulkUpdateLearners(newBulkClassUpdate);
    //if a new class was assigned and the current class was "" add license for each new class subject
    if (classUpdate.classes.some((cls) => cls.currentClass === "")) {
      const productIds = classUpdate.classes
        .filter((cls) => cls.currentClass === "" && cls.newClass !== "")
        .map((cls) => {
          const classGroup = filterStore.allClassGroups.find(
            (group) => group._id === cls.newClass
          );
          if (classGroup) {
            const product = licenseStore.getLicense?.products.find(
              (product) => product.product.subject === classGroup.subject
            );
            return product?._id;
          }
          return null;
        })
        .filter((id) => id !== null);
      await licenseStore.bulkAssignLicenses(selectedStudents.value, productIds);
    }
    //attach licenses in bulk for wonde schools if set to active
    if (request && schoolStore.currentSchool?.wondeId) {
      if (selectedStatus.value && selectedStatus.value == "active") {
        const productIds = schoolStore.currentSchool.schoolLicense.products.map(
          (product) => product._id
        );
        const licenseRequest = await licenseStore.bulkAssignLicenses(
          selectedStudents.value,
          productIds
        );
      }
    }

    //If update is successful, mark the edit as completed
    if (request) {
      response.value = "success";
      showEditComplete.value = true;
      updateMultipleLearners.value = false;
    } else {
      response.value = "failed";
      showEditComplete.value = true;
      updateMultipleLearners.value = true;
    }
  }

  // Emit resetEditModel event to reset the edit model
  // emit('resetEditModel');
};

const handleClassChange = (
  subjectId: string,
  newClassId: string,
  previousClassId: string
) => {
  if (newClassId && !previousClassId) {
    //if the previous value was null and the new value is not null, inscrease the license count
    const license = licenseStore.getLicense;
    const licenseProduct = license?.products.find(
      (product) => product.product.subject === subjectId
    );
    if (licenseProduct) {
      for (const student of selectedStudents.value) {
        licenseStore.incrementSchoolLicenseSeatsUsed(licenseProduct._id);
      }
    }
  } else if (previousClassId && !newClassId) {
    //if the previous value was not null and the new value is null, decrease the license count
    const license = licenseStore.getLicense;
    const licenseProduct = license?.products.find(
      (product) => product.product.subject === subjectId
    );
    if (licenseProduct) {
      for (const student of selectedStudents.value) {
        licenseStore.decrementSchoolLicenseSeatsUsed(licenseProduct._id);
      }
    }
  }
  if (licenseStore.isAnyLicenseSeatsExceeded(subjectId, newClassId)) {
    disabledBtn.value = true;
  } else {
    disabledBtn.value = false;
  }
  previousSelectedClasses[subjectId] = newClassId;
};

return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-2xl px-4 py-6 rounded-lg',
      open: updateMultipleLearners.value,
      onLocalModalOpen: cancelEdit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (selectedStudents.value.length > 1)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.$t("bulk_learner_edit_component.edit_multiple")), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(SchoolLicenseComponent, {
                  showAllLicenses: "true",
                  layoutType: "horizontal"
                })
              ]),
              _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t("bulk_learner_edit_component.select_options")), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t("bulk_learner_edit_component.class")), 1),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjects.value, (subject) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: subject.id
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("label", {
                          for: subject.name + 'Class',
                          class: "text-sm font-medium text-gray-700"
                        }, _toDisplayString(subject.name), 9, _hoisted_13),
                        _withDirectives(_createElementVNode("select", {
                          id: subject.name + 'Class',
                          class: "w-[60%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900",
                          "onUpdate:modelValue": ($event: any) => ((selectedClasses.value[subject.id]) = $event),
                          onChange: ($event: any) => (
                      handleClassChange(
                        subject.id,
                        selectedClasses.value[subject.id],
                        previousSelectedClasses.value[subject.id]
                      )
                      )
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getClassesForSubject(
                      subject.name
                    ), (classGroup) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: classGroup.id,
                              value: classGroup.id
                            }, _toDisplayString(classGroup.name), 9, _hoisted_15))
                          }), 128))
                        ], 40, _hoisted_14), [
                          [_vModelSelect, selectedClasses.value[subject.id]]
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              (!_unref(userStore).isClassGroupAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t("bulk_learner_edit_component.locked_journeys")), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("select", {
                        id: "lockedJourneys",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.lockedJourneys) = $event)),
                        onChange: updateLockedJourneys,
                        class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-base font-normal text-gray-900 w-full"
                      }, [
                        _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t("bulk_learner_edit_component.select")), 1),
                        _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t("bulk_learner_edit_component.catchup")), 1),
                        _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t("bulk_learner_edit_component.assessment")), 1),
                        _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.$t("bulk_learner_edit_component.none")), 1)
                      ], 544), [
                        [_vModelSelect, formData.value.lockedJourneys]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h2", _hoisted_24, _toDisplayString(_ctx.$t("bulk_learner_edit_component.language")), 1),
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("select", {
                    id: "language",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedLanguage).value = $event)),
                    class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-base font-normal text-gray-900 w-full"
                  }, _hoisted_30, 512), [
                    [_vModelSelect, selectedLanguage.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("bulk_learner_edit_component.status")), 1),
                _withDirectives(_createElementVNode("select", {
                  name: "status",
                  id: "status",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedStatus).value = $event)),
                  class: "w-[50%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                }, _hoisted_36, 512), [
                  [_vModelSelect, selectedStatus.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("button", {
                    class: "w-1/2 font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8",
                    onClick: cancelEdit
                  }, _toDisplayString(_ctx.$t("bulk_learner_edit_component.btn_cancel")), 1),
                  _createElementVNode("button", {
                    disabled: selectedStudents.value.length === 0 || disabledBtn.value
                ,
                    class: _normalizeClass(["", [
                  {
                    'w-1/2 font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white': true,
                    'bg-gray-300 cursor-not-allowed':
                      selectedStudents.value.length === 0,
                  },
                  disabledBtn.value ? 'cursor-wait' : 'cursor-pointer',
                ]]),
                    onClick: saveChanges
                  }, [
                    (_unref(learnerStore).loader.learner)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                          _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                          _createTextVNode(" " + _toDisplayString(_unref(learnerStore).loadingMessage), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t("bulk_learner_edit_component.btn_save")), 1))
                  ], 10, _hoisted_39)
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      widthClass: 'max-w-lg px-4 py-6 rounded-lg',
      open: showEditComplete.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", null, [
                (response.value == 'success')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-green-tick',
                        title: 'rl green tick',
                        "aria-hidden": "true"
                      })
                    ]))
                  : _createCommentVNode("", true),
                (response.value == 'failed')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-red-fail',
                        title: 'rl red fail',
                        "aria-hidden": "true"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (response.value == 'success')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_46, _toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.header")), 1))
                : _createCommentVNode("", true),
              (response.value == 'failed')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_47, _toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.failed_header")), 1))
                : _createCommentVNode("", true),
              (response.value == 'success')
                ? (_openBlock(), _createElementBlock("p", {
                    key: 2,
                    class: "font-normal text-sm text-gray-400 mt-2 text-center",
                    innerHTML: _ctx.$t('bulk_learner_edit_component.modal.sub_header', {
            count: selectedStudents.value.length,
          })
            
                  }, null, 8, _hoisted_48))
                : _createCommentVNode("", true),
              (response.value == 'failed')
                ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(_ctx.$t(
                "bulk_learner_edit_component.modal.sub_header_failed",
                { selectedStudents: selectedStudents.value.length }
              )), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("button", {
                  class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-2 w-full focus:outline-none",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (editCompleted()))
                }, _toDisplayString(_ctx.$t("student_table_view.confirm_modal.btn_edit")), 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})